import React from 'react';
import TryAgainFooterButtons from '../../../components/Buttons/TryAgainFooterButtons.jsx';
import TryAgainReturnToLoginButtons from '../../../components/Buttons/TryAgainReturnToLogin.jsx';
import { PhoneNumberInput } from '../PhoneNumberInput.jsx';
import { UsernameInput } from './UsernameInput.jsx';
import { PasswordInput } from './PasswordInput.jsx';

export function PasswordLoginForm({ 
  state, 
  onSubmit, 
  onChange, 
  onBeginRecaptchaValidation,
  onResetInitialState,
  onDropDownChange,
  initialData,
}) {
  const { 
    errors, 
    businessLogin, 
    model, 
    phoneError,
    isProcessing
  } = state;

  return (  
      <form onSubmit={onSubmit} noValidate>
        {phoneError ? (
          <PhoneNumberInput
            model={model}
            errors={errors}
            businessLogin={businessLogin}
            onChange={onChange}
            onDropDownChange={onDropDownChange}
            initialData={initialData}
            {...state}
          />
        ) : (
          <UsernameInput
            model={model}
            errors={errors}
            businessLogin={businessLogin}
            onChange={onChange}
          />
        )}

        <PasswordInput
          model={model}
          errors={errors}
          businessLogin={businessLogin}
          onChange={onChange}
        />

        

        {!phoneError ? (
          <TryAgainFooterButtons 
            fromLogin={true} 
            isB2bAccount={businessLogin} 
            confirm={onBeginRecaptchaValidation} 
            isProcessing={isProcessing} 
          />
        ) : (
          <TryAgainReturnToLoginButtons 
            Login={onBeginRecaptchaValidation} 
            resetInitialState={onResetInitialState} 
            isProcessing={isProcessing} 
          />
        )}
      </form>   
  );
}